import { render } from "./PreciosSection.vue?vue&type=template&id=db37169a&scoped=true"
import script from "./PreciosSection.vue?vue&type=script&lang=js"
export * from "./PreciosSection.vue?vue&type=script&lang=js"

import "./PreciosSection.vue?vue&type=style&index=0&id=db37169a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db37169a"]])

export default __exports__